// Service A/B Testing (expériences).
import { getRequest, postRequest, deleteRequest } from "./api/apiService";

export const EXPERIMENT_TYPES = [
  { value: "creative", label: "Créa" }, { value: "audience", label: "Audience" },
  { value: "copy", label: "Copy" }, { value: "landing", label: "Landing" }, { value: "cta", label: "CTA" },
];
export const METRICS = [["cvr", "Taux de conversion"], ["cpa", "CPA"], ["roas", "ROAS"]];

export const fetchExperiments = () => getRequest("/api/experiments");
export const createExperiment = (payload) => postRequest("/api/experiments", payload);
export const fetchResults = (id) => getRequest(`/api/experiments/${id}/results`);
export const declareWinner = (id, winner) => postRequest(`/api/experiments/${id}/winner`, { winner });
export const removeExperiment = (id) => deleteRequest(`/api/experiments/${id}`);
